import React from 'react'
import {
  Box,
  ButtonColorVariant,
  ButtonSize,
  Color,
  Display,
  Divider,
  FlexDirection,
  Heading3,
  JustifyContent,
  ModalBody,
  ModalButton,
  ModalFooter,
  ModalHeader,
  Overflow,
} from '@gousto-internal/citrus-react'
import { Recipe, RecipeUUID } from '@library/menu-service'
import { RecipeItem } from '../Recipe/RecipeItem'
import { InfoWarning } from '../Info/InfoWarning'
import { InfoSuccess } from '../Info/InfoSuccess'

type ContentProps = {
  numberOfPortionsPerBox: number
  recipes: Recipe[]
  submitRemovedRecipes: (recipes: RecipeUUID[]) => void
  goBack: () => void
}

export const Content = ({ recipes, submitRemovedRecipes, goBack }: ContentProps) => {
  const unavailableRecipes = recipes.filter((recipe) => !recipe.isAvailable)

  const isAnyRecipeOutOfStock = unavailableRecipes.length > 0

  const unavailableRecipeIds = unavailableRecipes.map((recipe) => recipe.id)
  const validRecipes = recipes.filter((recipe) => !unavailableRecipeIds.includes(recipe.id))

  const sortedRecipes = [...unavailableRecipes, ...validRecipes]

  return (
    <>
      <ModalHeader>
        <Heading3>Changes to basket</Heading3>
      </ModalHeader>
      <ModalBody paddingV={0}>
        <Box
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          justifyContent={JustifyContent.FlexStart}
          flexGrow={1}
          paddingV={4}
          height={['60vh']}
          overflowY={Overflow.Scroll}
        >
          {isAnyRecipeOutOfStock ? (
            <InfoWarning messages={['Greyed out recipes are not available and will be removed.']} />
          ) : (
            <InfoSuccess />
          )}
          <Box
            display={Display.Flex}
            flexDirection={FlexDirection.Column}
            width="100%"
            height="100%"
            gap={2}
            paddingV={4}
            data-testid="recipes"
          >
            {sortedRecipes.map((recipe) => (
              <RecipeItem key={recipe.id} recipe={recipe} />
            ))}
          </Box>
        </Box>
      </ModalBody>
      <Divider paddingV={0} color={Color.ColdGrey_200} />
      <ModalFooter>
        <Box
          display={Display.Flex}
          gap={2}
          flexDirection={FlexDirection.Column}
          bg={Color.White}
          width="100%"
          paddingH={0}
        >
          <ModalButton
            colorVariant={ButtonColorVariant.Primary}
            size={ButtonSize.Large}
            onClick={() => submitRemovedRecipes(unavailableRecipeIds)}
            height="48px"
          >
            Update basket
          </ModalButton>
          <ModalButton
            colorVariant={ButtonColorVariant.Secondary}
            size={ButtonSize.Large}
            onClick={goBack}
            height="48px"
          >
            Back
          </ModalButton>
        </Box>
      </ModalFooter>
    </>
  )
}
